import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import useOutsideClick from 'utils/useOutsideClick';
import forms from 'constants/forms';

const UpdatePatientPcmStatusModal = ({ togglePopup, handleClick }) => {
  const ref = useRef();
  useOutsideClick(ref, () => togglePopup(false));

  return (
    <div className="patient-status__modal" ref={ref}>
      {forms.pcmStatuses.map(({ value, label }) => (
        <div
          className="patient-status__modal-item"
          key={value}
          onClick={() => {
            handleClick(value);
            togglePopup(false);
          }}
        >
          {label}
        </div>
      ))}
    </div>
  );
};

UpdatePatientPcmStatusModal.propTypes = {
  togglePopup: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default UpdatePatientPcmStatusModal;
